if (!window.__collectionQuickAdd) {
  window.__collectionQuickAdd = true;
  document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-quick-add]');
  if (!button || button.disabled) return;

  event.preventDefault();
  event.stopPropagation();

  const drawer = document.querySelector('cart-drawer');
  button.disabled = true;
  button.classList.add('loading');

  try {
    if (drawer) {
      drawer.setActiveElement(button);
      await drawer.addItemToCart(button.dataset.variantId);
    } else {
      await fetch(`${window.routes.cart_add_url}.js`, {
        ...fetchConfig(),
        body: JSON.stringify({ items: [{ id: button.dataset.variantId, quantity: 1 }] }),
      });
      window.location.href = window.routes.cart_url;
    }
  } catch (error) {
    console.error('Quick add failed', error);
  } finally {
    button.disabled = false;
    button.classList.remove('loading');
  }
  });
}